import React, { useEffect, useState } from 'react';
import LazyLoad from 'react-lazyload';
import { Link } from 'react-router-dom';
import { getPrincipalMessage } from '../Service/Api';
const removeHtmlTags = (str) => {
  return str.replace(/<[^>]*>/g, ''); // Removes anything between '<' and '>'
};
const Message = () => {
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);
  const [data3, setData3] = useState([]);
  useEffect(() => {
    const msgData = async () => {
      const msgDataGet = await getPrincipalMessage();
      const principalMsg = msgDataGet.filter((item) => item.category === "Manager");
      setData(principalMsg);
      const headgirl = msgDataGet.filter((item) => item.category === "HeadGirl");
      setData2(headgirl);
      const headboy = msgDataGet.filter((item) => item.category === "HeadBoy");
      setData3(headboy);
      const directorMsg = msgDataGet.filter((item) => item.category === "Principal");
      setData1(directorMsg);
    }
    msgData();
  }, [])

  return (
    <>
      <div className='message_blk'>
        <div className='d-flex'>
          {data.length > 0 ? data.map((item) => (
            <>
             <div className='message_content orderd-2'>
                <h5>{item.name}</h5>
                <h6>{item.designation}</h6>
                <p>{removeHtmlTags(item.message)}</p>
                <button className='button'><Link to="/manager">Read More </Link></button>
              </div>
              <div className='message_img chairman orderd-1'>
                <LazyLoad><img src={`https://webapi.entab.info/api/image/${item.attachments[0]}`} className='img-fluid msg-img' alt="Cannosa school"></img></LazyLoad>
                <LazyLoad><img src='https://webapi.entab.info/api/image/CSFL/public/images/read-more.gif' className='message-btn' alt="Cannosa school" /></LazyLoad>
              </div>
             
            </>
          )) : (
            <>
           
            <div className='message_content orderd-2'>
                <h5>Sr. Philomena Lobo</h5>
                <h6>Manager</h6>
                <p>Dear Parents, teachers’ , well wishers and all my wondecontainer-fluidul students.
“Education is a shared commitment between dedicated teachers, motivated students and enthusiastic parents with high expectations.”
I thank Almighty God for his innumerable graces bestowed upon us, that has always led this institution from the time of inception.</p>
                <button className='button'><Link to="/manager"> Read More </Link></button>
              </div>
              <div className='message_img chairman orderd-1'>
                <LazyLoad><img src="https://webapi.entab.info/api/image/CSFL/public/images/manager.png" className='img-fluid msg-img' alt="Cannosa school"></img></LazyLoad>
                <LazyLoad><img src='https://webapi.entab.info/api/image/CSFL/public/images/read-more.gif' className='message-btn' alt="Cannosa school" /></LazyLoad>
              </div>
              
            </>
          )}
          {data1.length > 0 ? data1.map((item) => (
            <>            
             <div className='message_img chairman orderd-2'>
                <LazyLoad><img src={`https://webapi.entab.info/api/image/${item.attachments[0]}`} className='img-fluid msg-img' alt="Cannosa school"></img></LazyLoad>
                <LazyLoad><img src='https://webapi.entab.info/api/image/CSFL/public/images/read-more.gif' className='message-btn' alt="Cannosa school" /></LazyLoad>
              </div>
            <div className='message_content orderd-1'>
                <h5>{item.name}</h5>
                <h6>{item.designation}</h6>
                <p>{removeHtmlTags(item.message)}</p>
                <button className='button'><Link to="/principal">Read More</Link></button>
              </div>
             
            </>
          )) : (
            <>
              <div className='message_img chairman orderd-2'>
                <LazyLoad><img src="https://webapi.entab.info/api/image/CSFL/public/images/principal.png" className='img-fluid msg-img' alt="Cannosa school"></img></LazyLoad>
                <LazyLoad><img src='https://webapi.entab.info/api/image/CSFL/public/images/read-more.gif' className='message-btn' alt="Cannosa school" /></LazyLoad>
              </div>
              <div className='message_content orderd-1'>
                <h5>Sr Rosy MP</h5>
                <h6>principal</h6>
                <p>Those who do not burn with love cannot start a fire” St. Magdalene of Canossa.
“Education is not so much the feeding of facts into the mind as the awakening of curiosity in the soul.”
Dear students, parents and staff members a warm welcome to all of you as we embark on a new academic year 2025-26 at Canossa School.</p>
                <button className='button'><Link to="/principal">Read More</Link></button>
              </div>
            </>
          )}
        </div>
        <div className='d-flex'>
          {data2.length > 0 ? data2.map((item) => (
            <>
             <div className='message_content orderd-2'>
                <h5>{item.name}</h5>
                <h6>{item.designation}</h6>
                <p>{removeHtmlTags(item.message)}</p>
                <button className='button'><Link to="/headgirl"> Read More </Link></button>
              </div>
              <div className='message_img chairman orderd-1'>
                <LazyLoad><img src={`https://webapi.entab.info/api/image/${item.attachments[0]}`} className='img-fluid msg-img' alt="Cannosa school"></img></LazyLoad>
                <LazyLoad><img src='https://webapi.entab.info/api/image/CSFL/public/images/read-more.gif' className='message-btn' alt="Cannosa school" /></LazyLoad>
              </div>
             
            </>
          )) : (
            <>
           
            <div className='message_content orderd-2'>
                <h5>Ananya Dwivedi</h5>
                <h6>head girl </h6>
                <p>Dear school community,
I am indeed filled with profound gratitude to serve as head girl of this reputed and prestigious institute. Whenever I look over my journey from nursery to 12, it always fills me with great honour and gratitude. From the moment I stepped in, I was nurtured with love, promise, education, values and challenges</p>
                <button className='button'><Link to="/headgirl"> Read More</Link></button>
              </div>
              <div className='message_img chairman orderd-1'>
                <LazyLoad><img src="https://webapi.entab.info/api/image/CSFL/public/images/head-girl.png" className='img-fluid msg-img' alt="Cannosa school"></img></LazyLoad>
                <LazyLoad><img src='https://webapi.entab.info/api/image/CSFL/public/images/read-more.gif' className='message-btn' alt="Cannosa school" /></LazyLoad>
              </div>
              
            </>
          )}
          {data3.length > 0 ? data3.map((item) => (
            <>            
             <div className='message_img chairman orderd-2'>
                <LazyLoad><img src={`https://webapi.entab.info/api/image/${item.attachments[0]}`} className='img-fluid msg-img' alt="Cannosa school"></img></LazyLoad>
                <LazyLoad><img src='https://webapi.entab.info/api/image/CSFL/public/images/read-more.gif' className='message-btn' alt="Cannosa school" /></LazyLoad>
              </div>
            <div className='message_content orderd-1'>
                <h5>{item.name}</h5>
                <h6>{item.designation}</h6>
                <p>{removeHtmlTags(item.message)}</p>
                <button className='button'><Link to="/headboy"> Read More </Link></button>
              </div>
             
            </>
          )) : (
            <>
              <div className='message_img chairman orderd-2'>
                <LazyLoad><img src="https://webapi.entab.info/api/image/CSFL/public/images/head-boy.png" className='img-fluid msg-img' alt="Cannosa school"></img></LazyLoad>
                <LazyLoad><img src='https://webapi.entab.info/api/image/CSFL/public/images/read-more.gif' className='message-btn' alt="Cannosa school" /></LazyLoad>
              </div>
              <div className='message_content orderd-1'>
                <h5>Nikhil Yadav</h5>
                <h6>head boy</h6>
                <p>Dear school community,
Being the head boy of an institution as prestigious as this, in itself is an honour for me.
I would call myself blessed if I get to serve this school even a bit and give my contribution into the betterment of the institution.</p>
                <button className='button'><Link to="/headboy">Read More</Link></button>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Message;
